export const CSS_CLASSES = {
  COMMENT_MENTION: 'comment-mention',
  USER_INFO: 'user-info',
} as const
